var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSerIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2125 6.1124L16.8875 2.8499C15.8125 2.3749 14.1875 2.3749 13.1125 2.8499L5.78754 6.1124C3.93754 6.9374 3.66254 8.0624 3.66254 8.6624C3.66254 9.2624 3.93754 10.3874 5.78754 11.2124L13.1125 14.4749C13.65 14.7124 14.325 14.8374 15 14.8374C15.675 14.8374 16.35 14.7124 16.8875 14.4749L24.2125 11.2124C26.0625 10.3874 26.3375 9.2624 26.3375 8.6624C26.3375 8.0624 26.075 6.9374 24.2125 6.1124Z",
    fill: "#cf3d31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 21.3C14.525 21.3 14.05 21.2 13.6125 21.0125L5.18752 17.2625C3.90002 16.6875 2.90002 15.15 2.90002 13.7375C2.90002 13.225 3.31252 12.8125 3.82502 12.8125C4.33752 12.8125 4.75002 13.225 4.75002 13.7375C4.75002 14.4125 5.31252 15.2875 5.93752 15.5625L14.3625 19.3125C14.7625 19.4875 15.225 19.4875 15.625 19.3125L24.05 15.5625C24.675 15.2875 25.2375 14.425 25.2375 13.7375C25.2375 13.225 25.65 12.8125 26.1625 12.8125C26.675 12.8125 27.0875 13.225 27.0875 13.7375C27.0875 15.1375 26.0875 16.6875 24.8 17.2625L16.375 21.0125C15.95 21.2 15.475 21.3 15 21.3Z",
    fill: "#cf3d31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 27.5C14.525 27.5 14.05 27.4 13.6125 27.2125L5.18752 23.4625C3.80002 22.85 2.90002 21.4625 2.90002 19.9375C2.90002 19.425 3.31252 19.0125 3.82502 19.0125C4.33752 19.0125 4.75002 19.425 4.75002 19.9375C4.75002 20.725 5.21252 21.4375 5.93752 21.7625L14.3625 25.5125C14.7625 25.6875 15.225 25.6875 15.625 25.5125L24.05 21.7625C24.7625 21.45 25.2375 20.725 25.2375 19.9375C25.2375 19.425 25.65 19.0125 26.1625 19.0125C26.675 19.0125 27.0875 19.425 27.0875 19.9375C27.0875 21.4625 26.1875 22.8375 24.8 23.4625L16.375 27.2125C15.95 27.4 15.475 27.5 15 27.5Z",
    fill: "#cf3d31"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerIcon01);
export default __webpack_public_path__ + "static/media/ser-icon01.4de2306fa8389bf661571cdcac7a683b.svg";
export { ForwardRef as ReactComponent };